import { render, staticRenderFns } from "./ClinicalSkills.vue?vue&type=template&id=6506291b&scoped=true&"
import script from "./ClinicalSkills.vue?vue&type=script&lang=js&"
export * from "./ClinicalSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506291b",
  null
  
)

export default component.exports